import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

@Component({
  selector: 'app-fixed-bc-line-list-validation',
  templateUrl: './fixed-bc-line-list-validation.component.html',
  styleUrls: ['./fixed-bc-line-list-validation.component.scss']
})
export class FixedBcLineListValidationComponent implements OnChanges {
  @ViewChild('table', { static: true }) table;
  @Input() form: UntypedFormGroup;
  bcLineFormArray: UntypedFormArray;
  displayedColumnsBC: string[] = ['libelle', 'qte', 'pu', 'tva', 'naCode', 'cg', 'ca1', 'ca2', 'complement', 'Equipement', 'CodeChantier', 'dLivraison', 'mntHt'];
  matDataSourceBCLigne: MatTableDataSource<AbstractControl> = new MatTableDataSource<AbstractControl>();

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.form) {
      this.bcLineFormArray = this.form.controls["bcLines"] as UntypedFormArray;
      this.reload();
    }
  }

  reload(): void {
    if (this.bcLineFormArray) {
      this.matDataSourceBCLigne = new MatTableDataSource<AbstractControl>(this.bcLineFormArray.controls);
    }
  }
}
